import React from 'react';
import { Icon } from '@gx-design/icon';
import { Button } from '@gx-design/button';
/**
 * @typedef {Object} HeaderProps
 * @property {string} [backLinkHref]
 * @property {string|function|React.ReactNode} title
 * @property {any} [actions]
 * @property {boolean} [hasBackBtn]
 * @property {boolean} [hasBackLink]
 * @property {string|function} [onBack]
 */

/**
 * @param {HeaderProps} props
 */
export let Header = ({ title, backLinkHref, hasBackBtn, hasBackLink, onBack, actions }) => (
    <div className="gx-head-section">
        {hasBackBtn && (
            <Button className="gx-button gx-button--iconOnly gx-head-section__back" iconOnly onClick={onBack}>
                <Icon name="arrow-left" />
            </Button>
        )}
        {hasBackLink && (
            <Button
                as="a"
                variant="ghost"
                className="gx-button gx-button--iconOnly gx-head-section__back"
                iconOnly
                href={backLinkHref}
            >
                <Icon name="arrow-left" />
            </Button>
        )}
        <div className="gx-head-section__title gx-title-1 gx-is-hidden-sm-down">{title}</div>
        {actions && (
            <div className="gx-head-section__actions gx-buttonGroup gx-is-hidden-sm-down gx-flex-gap-8">{actions}</div>
        )}
    </div>
);
